module.exports = __webpack_public_path__ + "img/bg_gongdanshujukanban.37904f2c.svg";